<template>
  <info-card
    v-if="notes"
    :info="notes"
  />
    <!-- <div v-if="notes" class="ut-mb-3 ut-mr-5 ut-p-4 ut-mb-3 ut-text-sm ut-bg-orange-200">
        <img src="@/assets/images/info.svg" alt="" />
        <slot>{{ notes }}</slot>
    </div> -->
</template>

<script>

import moment from 'moment';
import InfoCard from '@/components/Cards/InfoCard.vue';

export default {
  name: 'OtherAgentLeadStageChangeNotification',
  components: {
    InfoCard,
  },
  props: {
    leadId: {
      type: Number,
      require: true,
    },
    agentId: {
      type: Number,
      require: true,
    },
    lamStage: {
      type: Number,
      required: true,
    },
    vendorName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      notes: null,
    };
  },
  mounted() {
    this.getNotes();
  },
  methods: {
    getNotes() {
      const data = {};
      data.leadid = this.leadId;
      data.agentid = this.agentId;
      data.notetypeid = 15;
      this.$apiServices.oa.note.getNotes(data)
        .then((res) => {
          if (res && res.length > 0) {
            // If note is contactedStageType and agent is currently in referred or viewed or attempted stage
            if (res[res.length - 1].note === '{3}' && ([1,2,11].includes(this.lamStage))) {
              this.notes = `Another agent that we recommended contacted ${this.vendorName}
              at ${this.formatDateTime(res[res.length - 1].createddate)}`;
            // If note is ApprasiedStageType and agent is in contacted referred attempted or viewed stage
            } else if (res[res.length - 1].note === '{4}' && ([1,2,11,3].includes(this.lamStage))) {
              this.notes = `Another agent that we recommended appraised ${this.vendorName}'s property at ${this.formatDateTime(res[res.length - 1].createddate)}`;
            }
          }
          return this.notes;
        }, (err) => {
          console.log(err);
          return this.notes;
        });
    },
    formatDateTime(dateString) {
      const formatedDate = moment(new Date(`${dateString} UTC`)).format('D MMM YYYY');
      const formatedTime = moment(new Date(`${dateString} UTC`)).format('hh:mma');
      return `${formatedTime} on ${formatedDate}`;
    },
  },
};
</script>

<style lang="scss" scoped>
  div {
  border-radius: 3px;

  img {
      @apply ut-mr-3;
      width: 20px;
      vertical-align: middle;
  }

}
</style>
